import React from 'react';

const LoadingSpinner = () => (
  <div className="loading-state">
    <div className="spinner" />
  </div>
);

export default LoadingSpinner;
